export const userOnboardingMutation = (builder) => ({
  userOnboarding: builder.mutation({
    query: (credentials) => {
      const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';

      return {
        url: '/user_onboarding',
        method: 'POST',
        body: credentials,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token 
        },
      };
    },
  }),
});
